import { FaExclamationCircle, FaRegTrashAlt } from "react-icons/fa";
import Loader from "../../../../../../Atoms/Loader";

export default function DeleteFileModal({ isOpen, onClose, title, onConfirm, isLoading }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" id="delete-modal">
            <div className="modal-container">
                <button className="modal-close" onClick={() => onClose()}>×</button>

                <div className="modal-icon">
                    <FaExclamationCircle size={32} color="#FFD400" />
                </div>

                <h2 className="modal-title">Apagar arquivo?</h2>
                <p className="modal-description mb-3">
                    Deseja realmente apagar o arquivo <span className="modal-project"><strong>{title}</strong></span> ?
                </p>

                <div className="modal-actions">
                    {isLoading ? (
                        <div className="d-flex flex-row gap-2 align-items-center justify-content-between w-full">
                            <Loader/>
                            <span>Apagando arquivo...</span>
                        </div>
                    ) : (    
                        <>
                            <button 
                                className="btn-cancel"
                                onClick={() => {
                                    onClose()
                                }}
                            >
                                Cancelar
                            </button>

                            <button
                                className="btn-delete"
                                onClick={() => {
                                    onConfirm?.();
                                }}
                            >
                                <FaRegTrashAlt className="btn-delete-icon" />
                                Apagar
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}